import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';

import { FleetPage } from './fleet';

@NgModule({
  declarations: [FleetPage],
  imports: [IonicPageModule.forChild(FleetPage)],
})
export class FleetPageModule {}



// WEBPACK FOOTER //
// ./src/pages/fleet/fleet.module.ts